/**
 * @file: useServiceRecords.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { useInfiniteList } from '@euler/functions/useInfiniteList';
import { useServiceFactory } from '@euler/services/factory';

const kLimit = 15;

export const useServiceRecords = ({
  licensePlateNo,
  vin,
  endDate,
  endInclusive,
}: {
  licensePlateNo: string;
  vin: string;
  endDate?: string | Date;
  endInclusive?: boolean;
}) => {
  const { serviceRecordService } = useServiceFactory();
  return useInfiniteList({
    limit: kLimit,
    query: async offset => {
      return await serviceRecordService.search(
        {
          licensePlateNo,
          vin,
          endDate,
          endInclusive,
        },
        {
          items: true,
          events: false,
          comment: false,
          pendingIssues: false,
          troubleCodes: false,
          userMedias: false,
        },
        offset,
        kLimit,
      );
    },
  });
};
